/**
 * Scripts for Frontend Website
 */
$(document).ready(function(){
	$(".dropdown .options li").click(function(){
		 selectDropdownOption($(this).parent().parent().parent().parent().parent(),$(this));
	});

	$(".dropdown .menu").each(function(index,element){
		$(element).mousewheel(function(event){
			scrollDropDown($(element),event.deltaY);
		});
	});
	
	$("#overlay").click(function(){
		hideDropdown();
	});
	
	if(window.location.hash) {
		var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
		if(hash == "publications"){
			filterCategory($("#publications-filter"));
		}else if(hash == "reports"){ 
			filterCategory($("#reports-filter"));
		}
	}
	
	$(".categories button").click(function(){
		filterCategory($(this));
	})
	
	if($(".reports").length > 0){
		filterByType();
	}
	
	if($(".search-area input").val()){
		$(".search-area button").click();
	}
	
	$(".profile .preview-image").height($(".profile .preview-image").width());
	$(".latest .preview-image").height($(".latest .preview-image").width());
	$(".profile .preview-image .inner-frame").height($(".profile .preview-image .inner-frame").width());
	$(".latest .preview-image .inner-frame").height($(".latest .preview-image .inner-frame").width());
	
	if($(window).scrollTop() > 210){
		$("#header #menu").css({
			position:"fixed",
			marginTop:0,
			backgroundColor:"#a4af37",
			width:"100%",
			borderBottom:"3px solid #588648",
			padding:"35px 0px"
		});
		
		$("#header #menu #menu-items").css({
			width:"100%",
			maxWidth:"1500px",
			padding:"0px 50px",
			margin:"0 auto"
		});
		
		$("#header #menu #menu-items li a").css({
			color:"#FFFFFF",
		});
	}
});

$(window).resize(function(){
	$(".profile .preview-image").height($(".profile .preview-image").width());
	$(".latest .preview-image").height($(".latest .preview-image").width());
	$(".profile .preview-image .inner-frame").height($(".profile .preview-image .inner-frame").width());
	$(".latest .preview-image .inner-frame").height($(".latest .preview-image .inner-frame").width());
	
	var searchIcon = $("#content .filters .search-area button");
	if(searchIcon){
		if($(window).width() <= 640 && searchIcon.css("left") != "0px"){
			searchIcon.css({left:"31.25vw"});
		}else if($(window).width() > 640 && searchIcon.css("left") != "0px"){
			searchIcon.css({left:"200px"});
		}
	}
	
	if($(window).width() > 1024){
		$("#header").css({
			position:"static",
			width:"auto"
		})
				
		$("#content").css({
			paddingTop:0
		})
	}
})

var lastScroll = 0;
$(window).scroll(function(){
	if($(window).scrollTop() > 210){
		$("#header #menu").css({
			position:"fixed",
			marginTop:0,
			backgroundColor:"#a4af37",
			width:"100%",
			borderBottom:"3px solid #588648",
			padding:"35px 0px"
		});
		
		$("#header #menu #menu-items").css({
			width:"100%",
			maxWidth:"1500px",
			padding:"0px 50px",
			margin:"0 auto"
		});
		
		$("#header #menu #menu-items li a").css({
			color:"#FFFFFF",
		});
	}else{
		$("#header #menu").css({
			position:"static",
			marginTop:45,
			color:"inherit",
			backgroundColor:"inherit",
			width:"auto",
			border:"none",
			padding:0
		});
		
		$("#header #menu #menu-items").css({
			padding:"0px"
		});
		
		$("#header #menu #menu-items li a").css({
			color:"#58874A",
		});
	}
	
	if($(window).width() < 1024){
		if($(window).scrollTop() > 0){
			if($(window).scrollTop() > lastScroll){
				$("#header").css({
					position:"static",
					width:"auto"
				})
				
				$("#content").css({
					paddingTop:0
				})
			}else{
				$("#header").css({
					position:"fixed",
					width:"100%"
				})
				
				$("#content").css({
					paddingTop:100
				})
			}
		}else{
			$("#header").css({
				position:"static",
				width:"auto"
			})
				
			$("#content").css({
				paddingTop:0
			})
		}
	}
	
	lastScroll = $(window).scrollTop();
})

function toggleMenu(){
	if($(".wrapper").css("marginLeft") == "0px"){
		$("body").css("overflow-y","hidden");
		$(".wrapper").animate({marginLeft:-1*$("#mobile-menu").width()},500);
		$("#mobile-menu").animate({left:"20%"},500);
	}else{
		$("body").css("overflow-y","auto");
		$(".wrapper").animate({marginLeft:0},500);
		$("#mobile-menu").animate({left:"100%"},500);
	}
}

function searchSAI($event,root){
	$event.preventDefault();

	var searchBar = $("#header .search-area input");
	if(searchBar.css("left") !== "0px"){
		searchBar.animate({left:0},250);
	}else{
		location.href = root+"search?q="+searchBar.val();
	}
}

function filterByName(){
	$(".index").show();
	$(".sorter ul li a").removeClass();
	$(".sorter ul li #name-type").addClass("selected");
	
	var entries = {};
	
	$(".entries li").each(function(){
		var letter = $(this).attr("data-title").substr(0,1).toUpperCase();
		if(!(letter in entries)){
			entries[letter] = [];
		}
		
		entries[letter].push($(this));
	});
	
	//Populate Jumper
	var location = window.location;
	var activeUrl = location.protocol+"//"+location.hostname+location.pathname;
	
	var jumperContent = "";
	var letters = Object.keys(entries);
	for(var i=0; i < letters.length; i++){
		jumperContent += "<li id='"+letters[i]+"-link'><a href='"+activeUrl+"#"+letters[i]+"'>"+letters[i]+"</a></li>";
	}
	
	$(".index ul").html(jumperContent);
	
	var newSection = "";
	var letters = Object.keys(entries);
	letters.sort();
	for(var i=0; i < letters.length; i++){
		newSection += "<a  name='"+letters[i]+"'></a>";
		newSection += "<h3 class='listing-heading'>"+letters[i]+"</h3>";
		
		newSection += "<ul class='entries'>";
		for(var j=0; j < entries[letters[i]].length; j++){
			newSection += entries[letters[i]][j][0].outerHTML;
		}
		newSection += "</ul>";
	}
	
	$(".section").html(newSection);
	
	$(".listing-heading").each(function(){
		if($(this).next().find("li:visible").length > 0){
			$(this).show();
			$(".index li:contains('"+$(this).html()+"')").show();
		}else{
			$(this).hide();
			$(".index li:contains('"+$(this).html()+"')").hide();
		}
	});
}

function filterByType(){
	$(".index").hide();
	$(".sorter ul li a").removeClass();
	$(".sorter ul li #type-type").addClass("selected");
	
	var entries = {};
	
	$(".entries li").each(function(){
		var category = $(this).attr("data-category");
		if(!(category in entries)){
			entries[category] = [];
		}
		
		entries[category].push($(this));
	});
	
	var newSection = "";
	var types = Object.keys(entries);
	types.sort();
	for(var i=0; i < types.length; i++){
		newSection += "<h3 class='listing-heading'>"+types[i]+"</h3>";
		
		newSection += "<ul class='entries'>";
		for(var j=0; j < entries[types[i]].length; j++){
			newSection += entries[types[i]][j][0].outerHTML;
		}
		newSection += "</ul>";
	}
	
	$(".section").html(newSection);
	
	$(".listing-heading").each(function(){
		if($(this).next().find("li:visible").length > 0){
			$(this).show();
		}else{
			$(this).hide();
		}
	});
}

function filterByDate(){
	$(".index").hide();
	$(".sorter ul li a").removeClass();
	$(".sorter ul li #date-type").addClass("selected");
	
	var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
	var entries = {};
	
	$(".entries li").each(function(){
		var date = $(this).attr("data-month")+", "+$(this).attr("data-year");
		if(!(date in entries)){
			entries[date] = [];
		}
		
		entries[date].push($(this));
	});
	
	var newSection = "";
	var dates = Object.keys(entries);
	dates.sort().reverse();
	for(var i=0; i < dates.length; i++){
		newSection += "<h3 class='listing-heading'>"+months[dates[i].split(",")[0]-1]+", "+dates[i].split(",")[1]+"</h3>";
		
		newSection += "<ul class='entries'>";
		for(var j=0; j < entries[dates[i]].length; j++){
			newSection += entries[dates[i]][j][0].outerHTML;
		}
		newSection += "</ul>";
	}
	
	$(".section").html(newSection);
	
	$(".listing-heading").each(function(){
		if($(this).next().find("li:visible").length > 0){
			$(this).show();
		}else{
			$(this).hide();
		}
	});
}

function filterByDepartment(){
	$(".index").hide();
	$(".sorter ul li a").removeClass();
	$(".sorter ul li #department-type").addClass("selected");
	
	var entries = {};
	
	$(".entries li").each(function(){
		var department = $(this).attr("data-department");
		if(!(department in entries)){
			entries[department] = [];
		}
		
		entries[department].push($(this));
	});
	
	var newSection = "";
	var departments = Object.keys(entries);
	departments.sort();
	for(var i=0; i < departments.length; i++){
		newSection += "<h3 class='listing-heading'>"+departments[i]+"</h3>";
		
		newSection += "<ul class='entries'>";
		for(var j=0; j < entries[departments[i]].length; j++){
			newSection += entries[departments[i]][j][0].outerHTML;
		}
		newSection += "</ul>";
	}
	
	$(".section").html(newSection);
	
	$(".listing-heading").each(function(){
		if($(this).next().find("li:visible").length > 0){
			$(this).show();
		}else{
			$(this).hide();
		}
	});
}

function toggleAnswer(question){
	var targetHeight = $(question).find(".answer").height()+25;

	if(parseInt($(question).find(".answer").css("top")) < 0){
		$(question).find("h3").toggleClass("selected");
		$(question).find(".answer").animate({"top":"0"},500);
		$(question).find(".slider").animate({"height":targetHeight},500);
	}else{
		$(question).find(".answer").animate({"top":"-185"},500);
		$(question).find(".slider").animate({"height":0},500,function(){
			$(question).find("h3").toggleClass("selected");
		});
	}
}

var cachedScrollTop = 0;
function toggleDropdown(dropdown){
	if(!dropdown){
		dropdown = $(".dropdown");
	}
	
	dropdown.find(".menu").toggle();
	$("#overlay").toggle();
	
	if($("#overlay").is(":visible")){
		cachedScrollTop = $(document).scrollTop();
		$('html, body').css({
			'overflow-x': 'hidden',
			'overflow-y': 'hidden',
			'height': '100%'
		});
	}else{
		$('html, body').css({
			'overflow-x': 'hidden',
			'overflow-y': 'auto',
			'height': 'auto'
		});
		$(document).scrollTop(cachedScrollTop);
	}
}

function hideDropdown(){
	$(".dropdown").find(".menu").hide();
	$("#overlay").toggle();
	
	$('html, body').css({
		'overflow-x': 'hidden',
		'overflow-y': 'auto',
		'height': 'auto'
	});
}

function selectDropdownOption(dropdown,option){
	$(dropdown).find(".options li").removeClass("selected");
	option.addClass("selected");
	dropdown.find(".value").html(option.html());
	
	var activeYear = $(".year-picker:visible .value").html();
	var activeMonth = $(".month-picker:visible .value").html();
	
	if($(dropdown).hasClass('year-picker')){
		$(".month-picker").hide();
		$("#"+activeYear+"-month-picker").show();
		$(".month-picker .value").html("Select Month");
		$(".day-picker .value").html("Select Day");
	}
	
	if($(dropdown).hasClass('month-picker')){
		$(".day-picker").hide();
		$("#"+activeYear+"-"+activeMonth+"-day-picker").show();
		$(".day-picker .value").html("Select Day");
	}
}

function scrollDropDown(dropdown,direction){
	var options = $(dropdown).find(".options");
	var slider = $(dropdown).find(".slider");
	var gradations = options.find("li").length-8;
	var slideIncrement = 170/gradations;
	
	if(direction > 0 && parseInt(options.css("top")) < 0){
		options.css("top",(parseInt(options.css("top")) + 37)+"px");
		slider.css("marginTop",parseInt(slider.css("marginTop"))-slideIncrement);
	}else if(direction < 0 && parseInt(options.css("top")) > -37 * gradations){
		options.css("top",(parseInt(options.css("top")) - 37) + "px");
		slider.css("marginTop",parseInt(slider.css("marginTop"))+slideIncrement);
	}
}

function resetDate(dateFilter){
	dateFilter.find(".year-picker .value").html("Select Year");
	dateFilter.find(".month-picker .value").html("Select Month");
	dateFilter.find(".day-picker .value").html("Select Day");
	
	$(".month-picker").hide();
	$(".day-picker").hide();
}

var searchTerm = "";
function searchResources($event){
	$event.preventDefault();

	var searchArea = $("#content .filters .search-area");
	var searchBar = $("#content .filters .search-area input");
	var searchIcon = $("#content .filters .search-area button");
	if(searchBar.css("left") !== "0px"){
		searchBar.animate({left:0},0);
		
		if($(window).width() > 640){
			searchIcon.animate({left:200},250);
			searchArea.animate({width:255},250);
		}else{
			searchIcon.animate({left:"31.25vw"},250);
			searchArea.animate({width:"40vw"},250);
		}
		
		if ($(window).width() < 825){
			searchArea.css("margin-top", "1px");
		}
	}else{
		searchTerm = searchBar.val().toLowerCase();
		$(".categories button").first().click();
	
		if($(".entry:visible").length > 0){
			$("#no-records").hide();
		}else{
			$("#no-records").show();
		}
	}
}

function filterCategory(button){
	$(".categories button").removeClass("selected");
	button.addClass("selected");
	
	$('.entries li').hide();
	$(".jumper li").show();
	$(".section").show();
	$(".jumper").show();
	$(".no-results").hide();
			
	if(button.html() == "View All"){
		if(searchTerm){
			$('.entries li[data-title*="'+searchTerm+'"]').show();
		}else{
			$('.entries li').show();
		}
	}else{
		if(searchTerm){
			$('.entries li[data-type="'+button.html()+'"][data-title*="'+searchTerm+'"]').show();
		}else{
			$('.entries li[data-type="'+button.html()+'"]').show();
		}
	}
		
	var visibleSections = false;
	$(".section").each(function(){
		if($(this).find("li:visible").length == 0){
			$(this).hide();
			$("#"+$(this).find("h3").html()+"-link").hide();
		}else{
			visibleSections = visibleSections || true;
		}
	});
	
	if(!visibleSections){
		$(".jumper").hide();
		$(".no-results").show();
	}
	
	$(".listing-heading").each(function(){
		if($(this).next().find("li:visible").length > 0){
			$(this).show();
		}else{
			$(this).hide();
		}
	});

	if($(".entry:visible").length > 0){
		$("#no-records").hide();
	}else{
		$("#no-records").show();
	}
	
	$(".index li").each(function(){
		var letter = $(this).find("a").html();
		if($("h3:contains('"+letter+"'):visible").length){
			$(this).show();
		}else{
			$(this).hide();
		}
	});
}

function searchNews(){
	var activeYear = $(".year-picker:visible .value").html();
	var activeMonth = $(".month-picker:visible .value").html();
	
	var selectedYear = $(".year-picker .value").html();
	var selectedMonth = $("#"+activeYear+"-month-picker .value").html();
	var selectedDay = $("#"+activeYear+"-"+activeMonth+"-day-picker .value").html();
	
	var location = window.location;
	var searchUrl = location.protocol+"//"+location.hostname+location.pathname;
	
	if(selectedYear && selectedYear !== "Select Year"){
		searchUrl += "?year="+ selectedYear;
	}
	
	if(selectedMonth && selectedMonth !== "Select Month"){
		searchUrl += "&month="+ selectedMonth;
	}
	
	if(selectedDay && selectedDay !== "Select Day"){
		searchUrl += "&day="+ selectedDay;
	}
	
	location.href = searchUrl;
}